import { createContext, useContext } from "react";
import type { SlotContext, SlotProviderProps } from "@b2bportal/core-utilities";
import {
  CarAvailabilityLink,
  CarBreadcrumbs,
  CarPriceDisplay,
  CarAvailabilityCard,
  CarShopBookingSection,
  CarAvailabilitySearch,
} from "@tenant/cars";
import { CoreCarsComponent } from "~core-cars/types";

export const defaultCarSlots = () => ({
  [CoreCarsComponent.CarAvailabilityLink]: CarAvailabilityLink,
  [CoreCarsComponent.CarBreadcrumbs]: CarBreadcrumbs,
  [CoreCarsComponent.CarPriceDisplay]: CarPriceDisplay,
  [CoreCarsComponent.CarAvailabilityCard]: CarAvailabilityCard,
  [CoreCarsComponent.CarShopBookingSection]: CarShopBookingSection,
  [CoreCarsComponent.CarAvailabilitySearch]: CarAvailabilitySearch,
});

export type CarSlotType = ReturnType<typeof defaultCarSlots>;

const CarSlotContext = createContext<SlotContext<CarSlotType> | undefined>(
  undefined
);

export const CarSlotProvider = ({
  context,
  children,
}: SlotProviderProps<CarSlotType>) => {
  return (
    <CarSlotContext.Provider value={context}>
      {children}
    </CarSlotContext.Provider>
  );
};

const useSlotSystem = () => {
  const context = useContext(CarSlotContext);
  if (context == null) {
    throw new Error("useSlots must be used within a CarSlotProvider");
  }
  return context;
};

export const useCarSlot = () => {
  const context = useSlotSystem();
  return context.components;
};
